import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useLayoutEffect(() => {
    // Back/forward → restaurar posición guardada
    if (navType === 'POP') {
      const saved = sessionStorage.getItem('scrollRestore');
      if (saved) {
        const targetY = parseInt(saved, 10);
        sessionStorage.removeItem('scrollRestore');

        // Reintentar hasta que la página tenga suficiente altura
        let attempts = 0;
        const restore = () => {
          attempts++;
          window.scrollTo(0, targetY);
          const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
          if (attempts < 80 && maxScroll < targetY - 10) {
            requestAnimationFrame(restore);
          }
        };
        // Esperar al primer frame para que React haya renderizado
        requestAnimationFrame(restore);
        return;
      }
    }

    // Cualquier otra navegación → arriba
    window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
};

export default ScrollToTop;
